// src/contexts/financeiro/FormaPagContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { buscarFormasPag, adicionarFormaPag, atualizarFormaPag, excluirFormaPag } from '../../services/financeiro/FormaPagService.js';
import FormaPagSearch from '../../pages/financeiro/FormaPagSearch.js';
import FormaPag from '../../models/financeiro/FormaPag.js';
import Alert from '../../components/alert/Alert.js';

const FormaPagContext = createContext();

export const useFormaPag = () => useContext(FormaPagContext);

export const FormaPagProvider = ({ children }) => {
    const [formasPag, setFormasPag] = useState([]);
    const [formaPagSel, setFormaPagSel] = useState(new FormaPag());

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');

    //Modal para buscar formas de pagamento
    const [showSearchModalFormaPag, setShowSearchModalFormaPag] = useState(false);
    const handleSelectFormaPag = (formaPagSelect) => {        
        setShowSearchModalFormaPag(false);
        if (formaPagSelect) {   
            setFormaPagSel(formaPagSelect);               
        } else {
            setFormaPagSel(new FormaPag());            
        }
    };
    const showFormaPagSearch = () => {
        setShowSearchModalFormaPag(true);
    }

    const showMessage = (message, type = 'success') => {
        setAlertMessage(message);
        setAlertType(type);
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 3000);
    };

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await buscarFormasPag();
                setFormasPag(result);
            } catch (error) {
                console.error("Erro ao buscar formas de pagamento:", error);
            }
        };
        fetchDataFromAPI();
    }, []);

    const addFormaPag = async (formaPag) => {
        try {
            const result = await adicionarFormaPag(formaPag);
            setFormasPag([...formasPag, result]);
            showMessage('Forma de pagamento adicionada com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar forma de pagamento:", error);
            showMessage(error?.message || 'Erro ao adicionar forma de pagamento', 'danger');
            throw error;
        }
    };

    const updateFormaPag = async (formaPag) => {
        try {
            await atualizarFormaPag(formaPag);
            setFormasPag(formasPag.map(f => f.id === formaPag.id ? formaPag : f));
            showMessage('Forma de pagamento atualizada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar forma de pagamento:", error);
            showMessage(error?.message || 'Erro ao atualizar forma de pagamento', 'danger');
            throw error;
        }
    };

    const deleteFormaPag = async (id) => {
        try {
            await excluirFormaPag(id); // Exclusão da forma de pagamento no servidor
            setFormasPag(formasPag.filter(f => f.id !== id));
            showMessage('Forma de pagamento excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir forma de pagamento:", error);
            showMessage('Erro ao excluir forma de pagamento', 'danger');
        }
    };

    return (
        <FormaPagContext.Provider value={{ formasPag, formaPagSel, 
        addFormaPag, updateFormaPag, deleteFormaPag,
         showFormaPagSearch}}>
            <Alert
                show={showAlert}
                message={alertMessage}
                type={alertType}
                onClose={() => setShowAlert(false)}
            />

            <FormaPagSearch
                show={showSearchModalFormaPag}
                onHide={() => setShowSearchModalFormaPag(false)}
                onSelectFormaPag={handleSelectFormaPag}
            />
            {children}
        </FormaPagContext.Provider>
    );
};
